import { createContext } from 'react';

interface IMethods {
  toggleSelectableNumber: () => void;
  toggleAddColumn: (value?: IContext['addColumn']) => void;
  toggleDublikateBlock: () => void;
  setMode: React.Dispatch<React.SetStateAction<IContext['mode']>>;
  setAddFlat: React.Dispatch<React.SetStateAction<IContext['addFlat']>>;
  setSaveAll: React.Dispatch<React.SetStateAction<IContext['saveAll']>>;
}

export interface IContext extends IMethods {
  dublikateBlock: boolean;
  selectableNumber: boolean;
  mode: 'grid' | 'table' | 'tablePro' | ({} & string);
  addColumn?: {
    xaxis: number;
    entrance: number;
  };
  addFlat?: {
    entrance: number;
    floor: number;
    xaxis: number[];
    yaxis: number[];
  };
  saveAll: boolean;
}

export const Context = createContext({} as IContext);
